import { Caption, Body1 } from "@coherehealth/common";
import { Box } from "@mui/material";
import { useClinicalReviewStyles } from "../caseCompletePageStyles";
import { SplitFaxData } from "../caseCompletePageUtils";

interface SplitFaxOutcomeSectionProps {
  splitFaxData: SplitFaxData;
}

export const SplitFaxOutcomeSection = ({ splitFaxData }: SplitFaxOutcomeSectionProps) => {
  const classes = useClinicalReviewStyles();
  const { faxCohereId, newCaseIds } = splitFaxData;
  const splitCount = newCaseIds.length;

  const outcomeText = splitCount === 1 ? "1 new case created" : `${splitCount} new cases created`;

  return (
    <>
      <Box className={classes.outcomeCaseTrackingBox}>
        <Caption className={classes.caption}>Outcome</Caption>
        <Body1 className={classes.body1}>{outcomeText}</Body1>
      </Box>
      <Box className={classes.outcomeCaseTrackingBox}>
        <Caption className={classes.caption}>Fax ID</Caption>
        <Body1 className={classes.body1}>{faxCohereId}</Body1>
      </Box>
      <Box className={classes.outcomeCaseTrackingBox}>
        <Caption className={classes.caption}>New Case IDs</Caption>
        {newCaseIds.map((caseId) => (
          <Body1 key={caseId} className={classes.body1}>
            {caseId}
          </Body1>
        ))}
      </Box>
    </>
  );
};
